import React, { useContext, useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// LOCAL VARIABLES
import { DAILY_SALES_COLUMNS } from '../variables';

// GLOBAL CONTEXT
import { ListContext } from 'helpers/getListData';

// CORE COMPONENTS
import Sprite from 'core/tools/Sprite';

// LOCAL COMPONENTS
import DailySalesSearch from './DailySalesSearch';

// STYLES
import styles from './dailySalesTable.module.scss';
import { Col, Row } from 'react-bootstrap';

// MAIN COMPONENT
const DailySalesTable = () => {

  // CONTEXT
  const {
    result = [],
    preferences: {
      filters = {}
    }
  } = useContext(ListContext) || {};

  // MEMO
  const data = useMemo(
    () => filters['newUsed'] === undefined || filters['newUsed'] === '' ? result : result.filter((_row, i) => {
      const key = filters['newUsed'] === '1' ? 0 : 1;
      return i === key;
    }),
    [filters, result]
  )

  // RENDER
  return (
    <div className={styles.container}>
      <div className={styles.table}>
        {data.map(({ delivery_type, ...row }, i) => (
          <div key={i} className={styles.row}>
            <div className="d-flex flex-grow-1">
              <Row className="justify-content-between justify-content-lg-start">
                <Col className={styles.labelColumn} md={10}>
                  <div>{delivery_type}</div>
                </Col>
                <Col className="d-flex justify-content-end justify-content-lg-start" md={14}>
                  <div className={clsx('w-100', styles.addColumn)}>
                    <DailySalesSearch isNew={i === 0 && filters['newUsed'] !== '0'} />
                  </div>
                </Col>
              </Row>
            </div>
            <div className={styles.totals}>
            {DAILY_SALES_COLUMNS.map(({ key, icon, label }, j) => (
              <div key={j} className={styles.totalColumn}>
                <Sprite className="text-light me-3" use={icon} size="sm"/>
                <span className="text-muted me-auto me-lg-3">{label}</span>
                <span>{row[key]}</span>
              </div>
            ))}
            </div>
          </div>
        ))}
      </div>
    </div>  
  )
};


// EXPORT
export default DailySalesTable;
